var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"jobList"}},[_c('div',{staticClass:"job-wrap"},[_c('div',{staticClass:"search-box"},[_c('el-input',{attrs:{"placeholder":"搜索职位、公司"}}),_c('div',{staticClass:"search-icon"},[_vm._v(" 搜索 ")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }